import type { ProductMetrics } from '../../types/api'

interface RoadmapImpactProps {
  metrics: ProductMetrics
}

export function RoadmapImpact({ metrics }: RoadmapImpactProps) {
  const riskColor =
    metrics.enterprise_risk_label === 'critical' ? 'text-critical' :
    metrics.enterprise_risk_label === 'high'     ? 'text-high' :
    metrics.enterprise_risk_label === 'medium'   ? 'text-medium' :
                                                    'text-low'

  return (
    <div className="space-y-4">
      {/* 3 key metrics */}
      <div className="grid grid-cols-3 gap-4">
        <div className="border border-hairline rounded-lg shadow-card bg-panel px-5 py-5">
          <p className="text-[11px] font-semibold text-faint uppercase tracking-wider mb-2">
            Roadmap delay
          </p>
          <p className="text-[32px] font-semibold text-warn leading-none">
            {metrics.feature_delay_weeks_per_quarter.toFixed(1)}w
          </p>
          <p className="text-[12px] text-muted mt-1">per quarter vs debt-free</p>
          <p className="text-[11px] text-faint mt-0.5">
            {metrics.features_at_risk_count} features blocked by structural issues
          </p>
        </div>

        <div className="border border-hairline rounded-lg shadow-card bg-panel px-5 py-5">
          <p className="text-[11px] font-semibold text-faint uppercase tracking-wider mb-2">
            Competitive gap
          </p>
          <p className="text-[32px] font-semibold text-warn leading-none">
            {metrics.competitive_velocity_gap_percent.toFixed(0)}%
          </p>
          <p className="text-[12px] text-muted mt-1">slower than a clean codebase</p>
          <p className="text-[11px] text-faint mt-0.5">shipping velocity disadvantage</p>
        </div>

        <div className="border border-hairline rounded-lg shadow-card bg-panel px-5 py-5">
          <p className="text-[11px] font-semibold text-faint uppercase tracking-wider mb-2">
            Churn risk
          </p>
          <p className={`text-[32px] font-semibold leading-none ${riskColor}`}>
            {metrics.churn_risk_score.toFixed(0)}/100
          </p>
          <p className="text-[12px] text-muted mt-1">
            enterprise risk: <span className={`font-semibold ${riskColor}`}>{metrics.enterprise_risk_label}</span>
          </p>
          <p className="text-[11px] text-faint mt-0.5">
            {metrics.reliability_findings_count} reliability findings
          </p>
        </div>
      </div>
    </div>
  )
}
